import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './components/App';
import './styles/app.css';
// Imported for its side effect: it must be listening for Chrome's
// `beforeinstallprompt` before the first render, since that event fires while
// the sign-in screen is still up and is never replayed.
import './lib/install';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);

// Registered only in production: in dev it would sit in front of Vite's module
// graph and serve stale chunks through HMR.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // Not fatal -- the app works fine unregistered, it just cannot be
      // installed or opened offline.
      console.warn('Service worker registration failed', err);
    });
  });
}
